import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { getCodeData, getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import { fnSave } from "@shared/api/restApi";
import SnSheet from "@shared/components/Grid/SnSheet";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "src/widgets/CommonDialog";
import SnResizableLNR from "@shared/components/SnResizableLNR";
import SnButton from "@shared/components/SnButton";

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string;

  [key: string]: any;
}

const SN_MAS_BAS_REG_008 = forwardRef(({ Menuprops }: Props, ref) => {
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any[]>([]);
  const [dataSource1, setDataSource1] = useState<any>();
  const SharedFormref1 = useRef<any>();
  const gridref1 = useRef<any>(null);
  const searchRef = useRef<any>(null);
  const { userInfo } = global();
  const [focusedRowData, setFocusedRowData] = useState<any>();
  let SaveData: any = {};

  //#region grid 길이 관련
  let width1 = "99%";
  const menuSize = localStorage.getItem("menuSize");
  if (menuSize) {
    const menu = JSON.parse(menuSize);
    if (menu.SN_MAS_BAS_REG_008) {
      width1 = menu.SN_MAS_BAS_REG_008.grid1Width
        ? menu.SN_MAS_BAS_REG_008.grid1Width
        : width1;
    }
  }
  const [grid1Width, setGrid1Width] = useState<string | number>(width1);

  const [compareFields, setCompareFields] = useState<string[]>(["cd_item"]); // 비교할 필드를 상태로 저장
  const [codeDataList, setCodeDataList] = useState<Record<string, string>[]>(
    []
  ); // 비교 대상 테이블 data mas_item

  //  mas_item list

  //  메뉴에서 `cd_clas`, `cd_popup` 데이터를 한 번만 로드
  const [codeDataMap, setCodeDataMap] = useState(new Map());
  const [popupDataMap, setPopupDataMap] = useState(new Map());

  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData({});

        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums(rtn.grid.grid1);

        gridref1.current.resetGridData();
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    if (gridref1.current) {
      gridref1.current.setCodeDataList(codeDataList); //  SnSheet 내부에서 코드 데이터 갱신 메서드 실행
    }
  }, [codeDataList]); //  codeDataList가 변경될 때마다 실행

  const onSearch = async () => {
    try {
      console.log("까땜:", JSON.stringify(codeDataList, null, 2));

      const params = {
        id: "sn_mas_bas_reg_002_01",
        params: {
          cd_firm: userInfo.cd_firm,
          fg_item: "",
          fg_acct: "",
          tp_item: "",
          cd_mgmt1: "",
          cd_mgmt2: "",
          cd_mgmt3: "",
          yn_use: "",
          cd_grpitem: "",
          dc_search: "",
        },
      };

      setFocusedRowData(null);
      setDataSource1([]);
      const data: any = await fnGetDataSet(params);
      setDataSource1(data[0]);
      if (data[0] && data[0].length > 0) {
        // 1. 그리드 데이터가 바인딩되었음을 기다림
        await new Promise((resolve) => setTimeout(resolve, 50)); // 비동기 반영 대기 (최적화 가능)

        // 2. 첫 번째 행 선택 및 포커스 설정
        gridref1.current.selectAndFocusRow(0);
      }

      gridref1.current.resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onDelete = () => {
    const focusedCell = gridref1.current.api.getFocusedCell();
    let startRowIndex = focusedCell.rowIndex ?? 0;

    gridref1.current?.deleteRowByIndex(startRowIndex);
  };

  const onSave = async () => {
    try {
      const isValid = await Validation();
      if (!isValid) {
        return;
      }

      if (gridref1.current.getChange().modifiedRowcount === 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      if (
        gridref1.current.getChange().update &&
        gridref1.current.getChange().update.length > 0
      ) {
        const confirm = await showDialog(
          "confirm",
          "이미 등록된 내역이 있습니다. 덮어쓰시겠습니까?"
        );
        if (!confirm) {
          return;
        }
      }

      SaveData["mas_item"] = gridref1.current.getChange();

      await fnSave("SN_MAS_BAS_REG_002_SAVE_01", SaveData);
      gridref1.current.resetUpdate();
      SaveData = [];
    } catch (error: any) {}
  };

  const onFocusedRowChanged = useCallback((focusedRowData: any | null) => {
    setFocusedRowData(focusedRowData);
  }, []);

  // grid1의 width resize
  const onResizeStopH = (width: number) => {
    setGrid1Width(width);
  };

  useImperativeHandle(ref, () => ({
    onSearch,
    // onInsert,
    onDelete,
    onSave,
  }));

  const Validation = async (): Promise<boolean> => {
    //  Validation 실행하여 오류 체크
    const data = await getCodeData("mas_item", ""); // mas_item data insert update체크할 데이터 조회
    setCodeDataList(data); // 기존 데이터 목록 저장

    if (gridref1.current.api.getDisplayedRowCount() <= 1) {
      await showDialog("alter", "변경된 내용이 없습니다.");
      return true;
    }

    const isValid = await gridref1.current.validateData();

    if (!isValid) {
      showDialog("error", "오류내역을 확인해주세요.");
      return false;
    } else {
      return true;
    }
  };

  const onGrid1BtnsClick = async (id: string) => {
    if (id == "aButton_Init") {
      gridref1.current.resetGridData();
    }

    if (id == "aButton_Validation") {
      const isValid = await Validation();
      if (isValid) {
        showDialog("alter", "오류가 없습니다.");
      }
    }
  };

  return (
    <div className="h-full flex flex-col">
      <div className="w-full flex flex-row space-x-2 flex-grow overflow-x-auto">
        <SnResizableLNR
          width={grid1Width}
          minWidth={130}
          onResizeStop={onResizeStopH}
          enable={{ right: true }}
          menuName={Menuprops.cd_menu || "SN_MAS_BAS_REG_002"}
          defaultSize={{ grid2Width: grid1Width }}
        >
          <SnSheet
            ref={gridref1}
            enableAddRow={true}
            columnConfig={columns}
            rowData={dataSource1}
            onFocusedRowChanged={onFocusedRowChanged}
            isEditable={true} // 수정 가능여부
            codeDataList={codeDataList} // pk 체크용 데이터 전달
            compareFields={compareFields} // 비교할 필드 정보 전달
            title="품목정보"
            header={
              <div className="flex justify-end">
                <SnButton
                  text={"초기화"}
                  onClick={() => {
                    onGrid1BtnsClick("aButton_Init");
                  }}
                />
                <SnButton
                  text={"오류체크"}
                  onClick={() => {
                    onGrid1BtnsClick("aButton_Validation");
                  }}
                />
              </div>
            }
          />
        </SnResizableLNR>
      </div>
    </div>
  );
});

export default SN_MAS_BAS_REG_008;
